import styled from '@emotion/styled'
import { breakpoint, calcRem, fonts, metrics } from '../__styling'

const { margins, siteMetrics } = metrics.thenightly

export const StyledUserSetting = styled.div({
    fontFamily: fonts.thenightly.sansSerif,
    padding: calcRem(0, margins.m2l),
    display: 'flex',
    overflow: 'hidden',
    maxWidth: siteMetrics.mainContentWidth,
    margin: '0 auto',

    [breakpoint('lg')]: {
        padding: 0,
    },
})

export const StyledWrapper = styled.div({
    position: 'relative',
})
